export default "__VITE_ASSET__1xQgqL56__"